import {platformtoarr } from "@/libs/index";
export default {
	state: {
		monitorPlanList: [],
		wecharList: [],
		monitorPlanDetail: [],
		tableData:{data:[],total:0},
		lowPriceLinkProduct:[{}],
		lowPriceLinkPlatform:{},
		monitorTopInfo:{}
	},

	getters: {
		lowPriceLinkProduct:state =>{
			let legend = [];
			let seriesData = [];
			for(let item of state.lowPriceLinkProduct){
				item.productname = item.productname;
				legend.push(item.productname);
				seriesData.push({
					name:item.productname,
					value:item.islowprice
				});
			}
			return [{
				legend:legend,
				toolbox:true,
				type:'default',
				seriesData:seriesData
			}]
		},
		lowPriceLinkPlatform:state=>{
			let xData = [];
			let  islowpriceList = [];
			let notislowpriceList = [];
			for(let item of state.lowPriceLinkPlatform){
				xData.push(platformtoarr(item.platform.split(','))[0].name);
				islowpriceList.push(item.islowprice);
				notislowpriceList.push(item.notislowprice);
			}
			let seriesData = {
				legend:['正常价格','违规'],
				xData:xData,
				toolbox:true,
				data:[{
					name:'正常价格',
					data:notislowpriceList
				},{
					name:'违规',
					data:islowpriceList
				}]
			}
			return seriesData
		},
	},

	mutations: {
		setMonitorPlanDetail(state, payload) {
			payload = payload.map(item => {
				item.productidlist = item.productidlist ? JSON.parse(item.productidlist) : item.productidlist

				return item;
			})
			state.monitorPlanDetail = payload;
		},
		setWecharList(state, payload) {
			state.wecharList = payload;
		},
		setMonitorPlanList(state, payload) {
			state.monitorPlanList = payload;
		},
		setTableTotal(state,payload){
			state.tableData.total = payload.length;
		},
		setMonitorPlanModalDetail(state,payload){
			state.tableData.data = payload;
		},
		setMonitorPlanModaChart(state,payload) {
			state.lowPriceLinkPlatform = payload.platformlist;
			state.lowPriceLinkProduct = payload.productlist;
			state.monitorTopInfo = payload;
		}
	},

	actions: {
		reqMonitorPlanList( { commit }, params ) {
			return new Promise((r, j) => {
				fetch({
					url: "hcm/hcmNewMonitorProduct/getPage",
					method: "get",
					params: params,
				}).then((res) => {
					if(res.status === '10000') {
						commit('setMonitorPlanList', res.data.content);
						r(res.data);
					}
				}).catch(() => {
					j();
				})
			})
		},
		reqWecharList( { commit }, params ) {
			return new Promise((r, j) => {
				fetch({
					url: "hcm/hcmNewMonitorProduct/getWecharList",
					method: "get"
				}).then((res) => {
					if(res.status === '10000') {
						commit('setWecharList', res.data);
						r(res.data);
					}
				}).catch(() => {
					j();
				})
			})
		},
		reqMonitorPlanDetail( { commit }, params ) {
			return new Promise((r, j) => {
				fetch({
					url: "hcm/hcmNewMonitorProduct/getDetailCountById",
					method: "get",
					params: params,
				}).then((res) => {
					if(res.status === '10000') {
						commit('setMonitorPlanDetail', res.data.content);
						r(res.data);
					}
				}).catch(() => {
					j();
				})
			})
		},
		reqMonitorPlanModalDetail( {commit },params ) {
			return new Promise((r, j) => {
				fetch({
					url: "hcm/wechat/getMonitorDetailByIdAndTime",
					method: "get",
					params: params,
				}).then((res) => {
					if(res.status === '10000') {
						let tableData = [];
						if(!params.type){
							commit('setMonitorPlanModaChart', res.data);
						}else{
							if(params.type === 'platform'){
								let payload = res.data.platformlist;
								for(let i = 0;i<payload.length;i++){
									if(payload[i].platform)
									payload[i].platform = platformtoarr(payload[i].platform.split(','))[0].name
								}
								tableData = payload;
							}else{
								tableData = res.data.productlist;
							}
							commit('setMonitorPlanModalDetail', tableData);
							commit('setTableTotal', tableData);
						}
						r();
					}
				}).catch(() => {
					j();
				})
			})
		}
	},
}